import { createElement } from 'react';
import { templateMapping } from '../mapping';

// TODO: Error Handling
export const getTemplate = (templateId, props = {}) => {
  return !!templateMapping[templateId] ? (
    createElement(templateMapping[templateId], props)
  ) : (
    <div>{`Template with id ${templateId} does not exist.`}</div>
  );
};
